import { Component, Input, OnInit, OnDestroy, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-style-view',
    templateUrl: './style-view.component.html',
    styleUrls: ['./style-view.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class StyleViewComponent implements OnInit, OnDestroy {
  @Input() mainColor: string = '#00733f';
  
  private styleElement: HTMLStyleElement | null = null;

  constructor() {}

  ngOnInit(): void {
    this.injectStyles();
  }

  ngOnDestroy(): void {
    this.removeStyles();
  }

  private injectStyles(): void {
    // Remove existing styles if any
    this.removeStyles();
    
    // Create style element
    this.styleElement = document.createElement('style');
    this.styleElement.type = 'text/css';
    this.styleElement.innerHTML = this.generateStyles();
    
    // Append to head
    document.head.appendChild(this.styleElement);
  }

  private removeStyles(): void {
    if (this.styleElement && this.styleElement.parentNode) {
      this.styleElement.parentNode.removeChild(this.styleElement);
      this.styleElement = null;
    }
  }

  private generateStyles(): string {
    return `
      a.from-journal {
        color: ${this.mainColor} !important;
      }
      h1.from-journal {
        color: ${this.mainColor} !important;
      }
      h4.from-journal {
        color: ${this.mainColor} !important;
      }
      strong.from-journal {
        color: ${this.mainColor} !important;
      }
      span.from-journal {
        color: ${this.mainColor} !important;
      }
      span.doi-label.from-journal {
        color: ${this.mainColor} !important;
      }
      .doi-text {
        color: ${this.mainColor} !important;
      }
      i.from-journal {
        color: ${this.mainColor} !important;
      }
      div.from-journal {
        background-color: ${this.mainColor} !important;
      }
      .from-journal-content a {
        color: ${this.mainColor} !important;
      }
      .countdown-number {
        color: ${this.mainColor} !important;
      }
      .tabs-vertical .nav-item.active .nav-link, .nav-link:hover {
        border-right-color: ${this.mainColor} !important;
      }
      .tabs-bottom .nav-item.active .nav-link, .nav-link:hover {
        border-bottom-color: ${this.mainColor} !important;
      }
      .btn-primary {
        background-color: ${this.mainColor} !important;
        border-color: unset !important;
      }
      .badge-custom {
        // background-color: ${this.mainColor} !important;
        color: ${this.mainColor};
        border: 1px solid ${this.mainColor} !important;
        cursor: pointer;
      }
      #header .header-nav.header-nav-line nav > ul li:hover > a {
        color: ${this.mainColor};
      }
      #header .header-nav.header-nav-line nav > ul li:hover > a:before {
        background: ${this.mainColor};
      }
      #citationContainer .blockquote-primary {
        border-color: ${this.mainColor} !important;
      }
      span.at-icon-wrapper {
        background-color: ${this.mainColor} !important;
      }
      .owl-custom-years .owl-item.active.center {
        border-bottom: 2px solid ${this.mainColor} !important;
      }
      .header-btn-collapse-nav {
        background: ${this.mainColor} !important;
      }
    `;
  }
}
